import {IAddressItem, IEditableAddressItem} from './addressItem.types';
import {ServiceTypesDictDto} from './api-v2.types';
import {IContract} from './contract.types';
import {IDevice} from './device.types';
import {IJSONResponse} from './json-response.types';
import {IPageableObject} from './pageable.types';
import {IReasonRejectionsDict} from './reasonRejectionsDict.types';
import {ITaskLocationsDict} from './taskLocationsDict.types';
import {IAccountGroup} from './user-account-groups.types';
import {IUserAccount} from './user-account.types';

export type TypeServiceRequestStatusCode =
  | 'CREATED'
  | 'READY_TO_PROCESS'
  | 'NOTIFYING'
  | 'IN_PROGRESS'
  | 'EXECUTED'
  | 'REJECTED'
  | 'DONE'
  | 'CANCELLED'
  | 'DELAYED'
  | 'APPROVED'
  | 'ARCHIVED';

export enum StatusCodeEnum {
  CREATED = 'CREATED',
  READY_TO_PROCESS = 'READY_TO_PROCESS',
  NOTIFYING = 'NOTIFYING',
  IN_PROGRESS = 'IN_PROGRESS',
  EXECUTED = 'EXECUTED',
  REJECTED = 'REJECTED',
  DONE = 'DONE',
  CANCELLED = 'CANCELLED',
  DELAYED = 'DELAYED',
  APPROVED = 'APPROVED',
  ARCHIVED = 'ARCHIVED',
}

export type MetadataType = 'MODEL' | 'SOURCE_CONTENT' | 'WORK_DATA';

export interface IFullAddress {
  id: string;
  region?: IAddressItem;
  street?: IAddressItem;
  district?: IAddressItem;
  city?: IAddressItem;
  fullAddress?: string | null;
  fiasAddress?: string | null;
  postalCode?: string | null;
  house?: string | null;
  building?: string | null;
  apartment?: string | null;
  cadastre?: string | null;
  latitude?: string | null;
  longitude?: string | null;
}

export interface IEditableFullAddress extends Omit<IFullAddress, 'id' | 'region' | 'street' | 'city' | 'district'> {
  region: IEditableAddressItem | null;
  city: IEditableAddressItem | null;
  street: IEditableAddressItem | null;
  district: IEditableAddressItem | null;
}

export interface IServiceRequest {
  id: number;
  requestId?: string;
  createdBy?: string;
  contract: IContract;
  contractId: number;
  companyId?: string;
  sourceContent?: Record<string, {description: string; value: string}>;
  workData?: Record<string, {description: string; value: string}>;
  statusCode: TypeServiceRequestStatusCode;
  house: string;
  building?: string;
  apartment: string;
  region: IAddressItem;
  street: IAddressItem;
  city: IAddressItem;
  fullAddress: string;
  serviceType: ServiceTypesDictDto;
  managerId: number;
  manager: IUserAccount;
  workerId?: number;
  worker?: IUserAccount;
  workerGroup?: IAccountGroup;
  workerGroupId?: number;
  createdDate: string;
  installationLocation?: string;
  taskLocationCode?: string;
  taskLocation?: ITaskLocationsDict;
  description?: string;
  executedDate?: string;
  customer?: string;
  postalCode?: string;
  email?: string;
  customerPhone?: string;
  reasonRejectionCode?: string;
  reasonRejection?: IReasonRejectionsDict;
  reasonDelayCount?: number;
  hasDeviceData?: boolean;
  reasonStatusCodeChanged?: string;
  companyName?: string;
  device?: IDevice;
  extNumber?: string;
  address: IFullAddress;
  workers: IUserAccount[];
  onRevision?: boolean;
}

export interface IServiceRequestParams {
  status?: TypeServiceRequestStatusCode | TypeServiceRequestStatusCode[];
  taskId?: string;
  region?: string;
  house?: string;
  city?: string;
  street?: string;
  serviceType?: string;
  taskLocationCode?: string;
  counter?: number;
  archive?: boolean;
}

export interface IServiceRequestMetadata {
  id: number;
  name: string;
  modelName: string;
  mandatory: boolean;
  description?: string;
  metadataType: MetadataType;
}

export interface IServiceRequestStatusHistory {
  id: number;
  rev: number;
  revType: 'ADD' | 'MOD' | 'DEL';
  statusCode: TypeServiceRequestStatusCode;
  reasonStatusCodeChanged?: string;
  author?: IUserAccount;
  date: string;
  archived?: boolean;
}

export interface IJSONResponseListServiceRequestDto extends IJSONResponse {
  data: IServiceRequest[];
}

export interface IPageServiceRequestDto {
  totalPages: number;
  totalElements: number;
  pageable: IPageableObject;
  numberOfElements: number;
  size: number;
  content: IServiceRequest[];
  number: number;
  sort: Record<string, any>;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export interface IServiceRequestFilters {
  apartment: string;
  street: string;
  city: string;
  region: string;
  counter: string;
  house: string;
  serviceType: string;
  status: string;
  taskLocationCode: string;
  workerUid: string;
}

export type GetServiceRequestPeriod = 'WEEK' | 'MONTH' | 'QUARTER' | 'YEAR' | 'ALL';
